<template>
  <section>
    <Zdialog
        width="90%"
        ref="zdialog"
        :title="$t('stockDiffer.stockDifferTitle') + modalParams.inventoryName"
        zDialogRef="z-dialog1"
        :show.sync="drawerVisible"
        :isConfirmClose="false"
        :isFooter="false"
        :modal="false"
        :hasBodyClass="false"
        :hasMinBtn="false"
        @close="close"
        @minimizeVal="minimizeVal"
        class="stockZdialog">
        <section slot="body">
          <div class="row">
            <section class="record-main">
              <searchForm :options="options" @searchHandel="searchHandel"></searchForm>
              <div class="differ-table">
                <div class="row align-center" v-if="totalObj" style="font-weight: bold;font-size: 13px;margin-top: -10px;margin-bottom: 5px;">
                  <div>{{$t('stockDiffer.accountTitle')}}：</div>
                  <div>{{$t('stockDiffer.stockTotal')}}：<span style="color:#F8475F;">{{totalObj.inventoryNumber || '0'}}</span></div>
                  <div>{{$t('stockDiffer.inventoryTotal')}}：<span style="color:#F8475F;">{{totalObj.stockNumber || '0'}}</span></div>
                  <div>{{$t('stockDiffer.totalDifference')}}：<span style="color:#F8475F;">{{totalObj.differenceNumber || '0'}}</span></div>
                  <div>{{$t('stockDiffer.totalDifferencePrice')}}：<span style="color:#F8475F;">{{totalObj.differencePrice || '0.00'}}đ</span></div>
                  <div>{{$t('stockDiffer.totalCompensate')}}：<span style="color:#F8475F;">{{totalObj.compensatePrice || '0.00'}}đ</span></div>
                </div>
                <grid-manager
                    v-if="gridOption.ajaxData"
                    :option="gridOption"
                    ref="grid"
                ></grid-manager>
              </div>
            </section>
            <colorSize
                ref="colorSize"
                v-if="queryInfoRow"
                :queryInfoRow="queryInfoRow"
                :queryType="queryForm.differState"
                :chooseAreaId="queryForm.areaConfigurationId"
                :invoiceState="modalParams.state"
                :stockMode="modalParams.mode"
                @changeValue="getChangeData">
            </colorSize>
          </div>
        </section>
        <section slot="titleRight" class="dialog-top">
            <div class="btnTop"></div>
        </section>
    </Zdialog>
    <changeDialog v-if="changeVisible" :fetchId="queryInfoRow.differenceUpdateId" @close="closeChage"></changeDialog>
  </section>
</template>

<script>
import Zdialog from '@/components/ZDialog/index.vue'
import searchForm from '@/components/searchForm.vue'
import colorSize from "../stockDifferList/components/colorSize"
import changeDialog from '../stockDifferList/components/changeDialog'
import {
  queryGoodsCategoryTree,
  queryStockDiffersList,
  queryWarehouseAreaConfig
} from '@/libs/http/modules/stock'
export default {
  props: {
    modalParams: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Zdialog,
    colorSize,
    changeDialog,
    searchForm
  },
  data() {
    return {
      loading: false,
      drawerVisible: false,
      options: {
        searchItem: [
          {
            id: '2',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: this.$t('stockDiffer.pleaseSelect'),
            label: this.$t('stockDiffer.differenceType'),
            value: '',
            resField: 'queryType',
            list: [
              { name: this.$t('stockDiffer.hasDifference'), value: "1" },
              { name: this.$t('stockDiffer.noDifference'), value: "2" },
            ]
          },
          {
            id: 'hasUpdate',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: this.$t('stockDiffer.pleaseSelect'),
            label: this.$t('stockDiffer.selectIsChange'),
            value: '',
            resField: 'hasUpdate',
            list: [
              { name: this.$t('stockDiffer.isYse'), value: "Y" },
              { name: this.$t('stockDiffer.isNo'), value: "N" },
            ]
          },
          {
            id: '3',
            type: 'goodsNoSelector',
            size: 'small',
            clearable: true,
            modelKey: 'goodsNo',
            placeholder: this.$t('stockDiffer.enterMaterialNo'),
            label: this.$t('stockDiffer.materialNo'),
            value: '',
            resField: 'goodsNo'
          },
          {
            id: '4',
            type: 'cascader',
            size: 'small',
            clearable: true,
            placeholder: this.$t('stockDiffer.pleaseSelect'),
            label: this.$t('stockDiffer.styleCategory'),
            props: {
              multiple: true,
              checkStrictly: true,
              emitPath: false,
              value: 'id',
              label: 'name',
              children: 'pojoList',
            },
            showAllLevels: false,
            value: '',
            resField: 'categoryId1',
            list: []
          },
          {
            id: '5',
            type: 'cascader',
            size: 'small',
            clearable: true,
            placeholder: this.$t('stockDiffer.pleaseSelect'),
            label: this.$t('stockDiffer.styleType'),
            props: {
              multiple: true,
              checkStrictly: true,
              emitPath: false,
              value: 'id',
              label: 'name',
              children: 'pojoList',
            },
            value: '',
            resField: 'categoryId2',
            list: []
          },
          {
            id: '7',
            type: 'cascader',
            size: 'small',
            clearable: true,
            placeholder: this.$t('stockDiffer.pleaseSelect'),
            label: this.$t('stockDiffer.timeCategory'),
            props: {
              multiple: true,
              checkStrictly: true,
              emitPath: false,
              value: 'id',
              label: 'name',
              children: 'pojoList',
            },
            showAllLevels: false,
            value: '',
            resField: 'categoryId3',
            list: []
          },
          // {
          //   id: '6',
          //   type: 'select',
          //   size: 'small',
          //   clearable: true,
          //   placeholder: '请选择',
          //   label: '区域',
          //   value: '',
          //   resField: 'areaId',
          //   list: []
          // }
        ],
        // 确认按钮
        sureBtnVisable: true,
        sureBtnType: 'primary',
        sureBtnSize: 'small',
        sureBtnText: this.$t('stockDiffer.query'),
        restBtnVisable: true,
        restBtnType: '',
        restBtnSize: 'small',
        restBtnText: this.$t('stockDiffer.reset'),
      },
      queryForm: {},
      changeVisible: false,
      changeList: [],
      queryInfoRow: null,
      queryIndex: '',
      gridOption: {
        gridManagerName: "stockDifferList",
        height: '72vh',
        firstLoading: true,
        isCombSorting: false,
        supportCheckbox: false,
        lineHeight: '30px',
        autoOrderConfig: {
          width: 50,
          fixed: undefined
        },
        checkboxConfig: {
          useRowCheck: true,
          fixed: 'left'
        },
        useTrFocus: true,
        supportAjaxPage: true,
        pageSize: 500,
        sizeData: [100, 200, 500, 1000],
        disableBorder: false,
        disableLine: false,
        i18n: this.$cache.local.get('locale') === 'vn' ? 'vn' : '',
        columnData: [
          // {
          //   key: 'areaName',
          //   text: '区域',
          //   width: '100px'
          // },
          {
            key: 'goodsNo',
            text: this.$t('stockDiffer.materialNo'),
            width: '120px',
            template: () => {
              return `
                  <div :style="{color: row.updateState === '1' ? '#FF9000 !important' : row.updateState === '2' ? '#44D169 !important' : row.updateState === '3' ? 'red !important': ''}">{{row.goodsNo}}</div>
              `
            }
          },
          {
            key: 'goodsName',
            text: this.$t('stockDiffer.goodsName'),
            width: '150px'
          },
          {
            key: 'inventoryNumber',
            text: this.$t('stockDiffer.inventoryQuantity'),
            sorting: '',
            width: '100px'
          },
          {
            key: 'stockNumber',
            text: this.$t('stockDiffer.stockQuantity'),
            sorting: '',
            width: '100px'
          },
          {
            key: 'differenceNumber',
            text: this.$t('stockDiffer.differenceQuantity'),
            sorting: '',
            width: '100px',
            template: () => {
              return `
                <div :style="{color: row.differenceNumber != 0 ? 'red' : ''}">{{row.differenceNumber}}</div>
              `
            }
          },
          {
            key: 'retailPrice',
            text: this.$t('stockDiffer.retailPrice'),
            sorting: '',
            width: '120px'
          },
          {
            key: 'tagPrice',
            text: this.$t('stockDiffer.tagPrice'),
            sorting: '',
            width: '100px'
          },
          {
            key: 'inventoryPrice',
            text: this.$t('stockDiffer.summaryInventoryPrice'),
            sorting: '',
            width: '100px'
          },
          {
            key: 'compensatePrice',
            text: this.$t('stockDiffer.compensateAmount'),
            sorting: '',
            width: '100px',
            template: () => {
              return `
                <div :style="{color: row.compensatePrice != 0 ? 'red' : ''}">{{row.compensatePrice}}</div>
              `
            }
          },
          {
            key: 'typeCategory1',
            text: this.$t('stockDiffer.firstStyleCategory')
          },
          {
            key: 'typeCategory2',
            text: this.$t('stockDiffer.secondStyleCategory')
          },
          {
            key: 'styleCategory1',
            text: this.$t('stockDiffer.firstStyleType')
          },
          {
            key: 'styleCategory2',
            text: this.$t('stockDiffer.secondStyleType')
          },
          {
            key: 'timeCategory1',
            text: this.$t('stockDiffer.firstTimeCategory')
          },
          {
            key: 'timeCategory2',
            text: this.$t('stockDiffer.secondTimeCategory')
          }
        ],
        ajaxData: this.fetch,
        ajaxError: this.ajaxError,
        summaryHandler: (data) => {
          let list = [
            'inventoryNumber',
            'stockNumber',
            'differenceNumber',
            'compensatePrice'
          ]
          let obj = {
            goodsNo: this.$t('stockDiffer.summaryPageTotal')
          }
          list.forEach((key) => {
            obj[key] = data.reduce((c, R) => c + Number(R[key] || 0), 0)
          })
          return obj
        },
        rowClick: (row, rowIndex) => {
          this.showINfo(row, rowIndex);
          row.highlight = true;
        }
      },
      totalObj: null,
      pageTotal: null
    };
  },
  created() {
    this.drawerVisible = true;
    this.fetchQuerytree('0');
    this.fetchQuerytree('1');
    this.fetchQuerytree('2');
    this.fetchArea();
  },
  methods: {
    close() {
      this.$emit('close', ['close', this.modalParams])
    },
    minimizeVal(e) {
      //是否是最小化，是的话就传给父组件
      if (e) {
        this.$emit('close', ['', this.modalParams])
      }
    },
    isMinimize() {
      this.$refs['zdialog'].minimize()
    },

    fetchQuerytree(type){
      queryGoodsCategoryTree({
        queryType: type
      }).then(data=>{
        if (data && data.length) {
          if (type === '0') {
            this.options.searchItem[3].list = this.recursiveFilter(data);
          }
          if (type === '1') {
            this.options.searchItem[4].list = this.recursiveFilter(data);
          }
          if (type === '2') {
            this.options.searchItem[5].list = this.recursiveFilter(data);
          }
        }
      }).catch(error=>{})
    },
    recursiveFilter(arr) {
      const data = arr;
      data.forEach((item) => {
        if (item.pojoList && item.pojoList.length) {
          this.recursiveFilter(item.pojoList);
        } else {
          delete item.pojoList;
        }
      });
      return data;
    },
    fetchArea(){
      queryWarehouseAreaConfig().then(data => {
        if(data && data.items){
          data.items.map(item=>{
            item.value = item.id;
          })
          this.options.searchItem[5].list = data.items || []
        }
      }).catch( err => {
        this.$message({type: 'error', message:err,duration:2000,showClose:true})
      })
    },
    searchHandel(e){
      this.queryForm = e;
      GridManager.refreshGrid(this.gridOption.gridManagerName, true);
    },
    fetch(params) {
      const that = this;
      return new Promise(async (resolve, reject) => {
        try {
          let reqData = {
            id: that.modalParams.id,
            sortData: params.sortData,
            page: params.pageData.cPage,
            pageSize: params.pageData.pSize
          }
          for(let key in that.queryForm){
            if(key && key !== 'categoryId1' && key !== 'categoryId2' && key !== 'categoryId3' && key !== 'goodsNo'){
              reqData[key] = that.queryForm[key]
            }
          }
          if(this.queryForm.goodsNo){
            reqData['goodsNo'] = this.queryForm.goodsNo.join(' ')
          }
          let sortObj = {}
          if(params.sortData){
            if(params.sortData.inventoryNumber){
              sortObj['totalInventoryNumber'] = params.sortData.inventoryNumber
            }
            if(params.sortData.stockNumber){
              sortObj['totalStockNumber'] = params.sortData.stockNumber
            }
            if(params.sortData.differenceNumber){
              sortObj['totalDifferenceNumber'] = params.sortData.differenceNumber
            }
            if(params.sortData.retailPrice){
              sortObj['totalRetailPrice'] = params.sortData.retailPrice
            }
            if(params.sortData.tagPrice){
              sortObj['totalTagPrice'] = params.sortData.tagPrice
            }
            if(params.sortData.inventoryPrice){
              sortObj['totalInventoryPrice'] = params.sortData.inventoryPrice
            }
            if(params.sortData.compensatePrice){
              sortObj['totalDifferencePrice'] = params.sortData.compensatePrice
            }
          }
          if(JSON.stringify(sortObj) !== "{}"){
            reqData['sortData'] = sortObj
          }
          let categoryIds1 = [];
          let categoryIds2 = [];
          let categoryIds3 = [];
          if(this.queryForm.categoryId1){
            categoryIds1 = this.queryForm.categoryId1
          }
          if(this.queryForm.categoryId2){
            categoryIds2 = this.queryForm.categoryId2
          }
          if(this.queryForm.categoryId3){
            categoryIds3 = this.queryForm.categoryId3
          }
          if(categoryIds1.length || categoryIds2.length || categoryIds3.length){
            reqData['categoryIds'] = [...categoryIds1, ...categoryIds2, ...categoryIds3]
          }
          let data = await queryStockDiffersList(reqData);
          this.totalObj = data.differenceCollectInfo
          this.pageTotal = data.pageDifferenceCollectInfo
          if(!that.queryInfoRow){
            that.queryInfoRow = data.items[0];
          }else{
              that.queryInfoRow = data.items[this.queryIndex]
          }
          const tableData = {
            data: data.items,
            totals: Number(data.totalItem) || 0,
          };
          resolve(tableData);
        }catch(e) {
          reject(e);
        }
      });
    },
    ajaxError(e){
      this.$message({type: 'error', message: e, duration: 2000, showClose: true})
    },
    showINfo(row, index) {
      this.queryInfoRow = row;
      this.queryIndex = index;
      this.$nextTick(() => {
        this.$refs.colorSize.fetch();
      });
    },
    getChangeData(e){
      if(!this.queryInfoRow.differenceUpdateId){
        this.queryInfoRow.differenceUpdateId = e;
        GridManager.refreshGrid(this.gridOption.gridManagerName);
      }else{
        this.changeVisible = true;
      }
    },
    closeChage(e){
      this.changeVisible = false;
      if(e){
        GridManager.refreshGrid(this.gridOption.gridManagerName);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.record-main {
  width: calc(100% - 400px);
  .differ-table {
    padding: 0 10px;
    margin: 0 10px;
    div div{
      margin-right: 20px;
    }
  }
}
</style>
